import React, {Component} from 'react';
import './Publications.css';

class Publications extends Component {


    render() {
        return (

            <div id="publications" className="row home-block">

                <div>
                    <h2 className="title">Publications</h2>

                    <div>
                        <div className="type-publication">Publication en journal</div>
                        <ul>                         
						<li> <a href ="https://ieeexplore.ieee.org/abstract/document/9422268"> Dynamic allocation optimization in A/B tests using classification-based preprocessing - E. Claeys P. Gançarski , M. Maumy-Bertrand - H. Wassner -
            <em> IEEE Transactions on Knowledge and Data Engineering (TKDE), 03 May 2021 </em> </a> </li> 
         			   <li> <a href ="https://ieeexplore.ieee.org/abstract/document/9422268"> HAL Dynamic allocation optimization in A/B tests using classification-based preprocessing - E. Claeys P. Gançarski , M. Maumy-Bertrand - H. Wassner -
            <em> Pre print </em> </a> </li> 
						   
						</ul>
                        <div className="type-publication">Publication en conférences internationales avec comité de sélection</div>
                        <ul>

                         <li> <a href="https://hal.archives-ouvertes.fr/hal-02572428/">Learning Exploration for Contextual Bandit - D. Bouneffouf , E. Claeys -  
           <em>  Automation in Machine Learning (in conjunction with the KDD 2019 Conference)</em> , Anchorage, AK, United States, Août 2019.</a></li>
						<li> <a href="https://www.google.com/url?sa=t&rct=j&q=&esrc=s&source=web&cd=&ved=2ahUKEwj3z638of_qAhXHxIUKHRI0ADgQFjADegQIARAB&url=https%3A%2F%2Fhal.archives-ouvertes.fr%2Fhal-02572444%2Fdocument&usg=AOvVaw3tStgg8Sxc-pYeGacFFELW"> Regression Tree for Bandits Models in A/B Testing - E. Claeys, P. Gançarski, M. Maumy-Bertrand <em> International Symposium on Intelligent Data Analysis (IDA), Londres, United Kingdom, pages 52-62, Octobre 2017</em> <b>Chapitre d'ouvrage version étendu</b></a></li>
						</ul>	
                    </div>
					
					
					<div className="type-publication">Publications en conférence nationale</div>
                        <ul>
						<li> <a href="https://hal.archives-ouvertes.fr/hal-02572655"> Intégration des séries temporelles dans les A/B-Tests - E. Claeys P. Gançarski , M. Maumy-Bertrand, <em> E.G.C. Bruxelles  Janvier 2020.</em>, vol. RNTI-E-36, pp.121-132 <b>Avec Acte</b> </a> <b> - Article nominé au prix de meilleur papier "Académique" et au prix de meilleur papier "Applicatif"</b></li> 						   
		
						<li>  <a href="https://hal.archives-ouvertes.fr/hal-02572670">Gestion des logs dans les problèmes de bandits contextuels - E. Claeys P. Gançarski , M. Maumy-Bertrand, <em> Journées d'Etude en Statistique, Nancy, France- Juin 2019 </em> </a></li> 						   
						<li>  <a href="https://hal.archives-ouvertes.fr/hal-02572688"> Système de recommandation : algorithmes et application à la plateforme KeeSeeK - E. Claeys, M. Maumy-Bertrand , F. Bertrand , T. Nengsih, A. Delyon , A. Vidal 
        <em> Journées d'Etude en Statistique, Nancy, France, - Juin 2019 </em> </a> </li>
						<li>  <a href="https://www.google.com/url?sa=t&rct=j&q=&esrc=s&source=web&cd=&ved=2ahUKEwjk1Kr3nP_qAhVFz4UKHakbBvMQFjAAegQIAhAB&url=https%3A%2F%2Fhal.archives-ouvertes.fr%2Fhal-02572695%2Fdocument&usg=AOvVaw1ssnBm46PzmnuhCmmg8XR3">Approche contextuelle par régression pour les tests A/B - E. Claeys, P. Gançarski, M. Maumy-Bertrand -  <em> EGC, Paris, Janvier 2018 </em> vol. RNTI-E-34 pages 269-274.  <b> Avec Acte </b></a></li>
						<li>  <a href="https://hal.archives-ouvertes.fr/hal-02572736/">Conception d’un modèle généraliste pour l’évaluation d’un test A/B - E. Claeys, P. Gançarski, M. Maumy-Bertrand  <em>  EGC, Grenoble, 2017 </em> vol. RNTI-E-33 pages 423-424. <b>Avec Acte </b>  </a> </li>
						<li> <a href="https://arxiv.org/pdf/2005.02209.pdf">Approche paramétrique de bandits pour le test A/B. - E. Claeys, P. Gançarski, M. Maumy-Bertrand  <em> Conférence Nationale sur les Applications pratiques de l'Intelligence Artificielle (APIA) Caen, France, Janvier 2017 </em> pages 19-25. <b> Avec Acte </b> </a> </li>
						 
					</ul>
					
                
				
				 <div className="type-publication">Livre</div>
                 <ul>
				 <li>Modélisation statistique par la pratique avec R - F. Bertrand,  M. Maumy-Bertrand, E. Claeys - <em> Sciences Sup, Dunod (Eds) , 2019. </em> </li>
				 </ul>	
                </div>
					
            </div>



        );
    }
}

export default Publications;



// WEBPACK FOOTER //
// ./src/Components/Publications/Publications.js